import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers/';
import { connect } from 'react-redux';
import moment from 'moment';
import { isUndefined } from 'lodash';

import { toastType, createToast } from 'Common/ToastHelper';
import { withRouter } from 'react-router';
import { CEP_FUNDS_DUE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { CEPFundsDueReportForm } from './components/CEPFundsDueReportForm';
import { CEPFundsDueReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';

import { getReport, clearReport, getSites } from './state/report/actions';

import {
  getUserSetting,
  UserSettingsEnum,
} from 'Common/UserSettings/helpers/helper';

class CEPFundsDueReportContainer extends Component {
  componentDidMount() {
    this.props.getSites();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;

    if (error || isUndefined(error)) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        if (report === 'No Data') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        } else {
          ReportGeneration(report, 'CEP Funds Due Report');
        }
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: CEP_FUNDS_DUE_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    const data = { ...formValues, SelectedSites: this.props.selectedSites };

    if (data.SelectedSites && data.SelectedSites.length === 0) {
      return createToast(
        toastType.error,
        'Error',
        'Please select one or more sites to continue!',
        true
      );
    }

    this.props.getReport(data);
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? (
          <LoadingPage message={'Loading Report'} />
        ) : (
          undefined
        )}
        <Filter title={'CEP Funds Due'} />
        <Main {...this.getMainProps()}>
          <CEPFundsDueReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.AmtDueBfst]: this.props.AmtDueBfst
                ? parseFloat(this.props.AmtDueBfst).toFixed(2)
                : null,
              [Fields.AmtDueLunch]: this.props.AmtDueLunch
                ? parseFloat(this.props.AmtDueLunch).toFixed(2)
                : null,
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  //destructured
  const {
    report,
    loading,
    selectedSites,
    error,
  } = state.CEPFundsDueReportState.report;

  return {
    report: report,
    loading: loading,
    selectedSites: selectedSites,
    error: error,
    AmtDueBfst: getUserSetting(
      state,
      UserSettingsEnum.CEPFundsDueBFSTAmountDue
    ),
    AmtDueLunch: getUserSetting(
      state,
      UserSettingsEnum.CEPFundsDueLUNCHAmountDue
    ),
  };
};

export const CEPFundsDue = withRouter(
  connect(
    mapStateToProps,
    {
      getReport,
      clearReport,
      getUserSetting,
      getSites,
    }
  )(CEPFundsDueReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/cepfundsdue/CEPFundsDue.js